
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";

export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS";
export const SIGNUP_USER_FAIL = "SIGNUP_USER_FAIL";

export const SIGNUP_USER_CLEAR = "SIGNUP_USER_CLEAR";

export const LOGOUT = "LOGOUT";

export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAIL = "GET_CURRENT_USER_FAIL";

export const CLEAR_ERROR = 'CLEAR_ERROR';

export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_FAIL = "REFRESH_TOKEN_FAIL";

export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";

export const SET_REFRESH_TOKEN = "SET_REFRESH_TOKEN";

export const SET_USER_DATA = "SET_USER_DATA";

export const SET_USER_SITE = "SET_USER_SITE";